import { FC } from 'react'
import classNames from 'classnames'
import { SUPPORTED_LANGUAGES } from 'constants/i18n'
import { Language } from 'types/language'
import { useRouter } from 'next/router'
import { translateRoute } from 'utils/routes'
import styles from './LanguageSwitcher.module.scss'
import { useDispatch } from 'react-redux'
import { updateRegistrationInput } from 'store/registration/actions/updateRegistrationInputs'
import { InputGroupKeys, PersonalDataFieldKeys } from 'store/registration/types'

const LanguageSwitcher: FC = () => {
  // REDUX STORE
  const dispatch = useDispatch()

  // ROUTER
  const router = useRouter()

  // i18n
  const { pathname, asPath, locale: language } = router

  /**
   * Changes the language to the given one
   *
   * @param {Language} newLang
   */
  const changeLanguage = (newLang: Language) => {
    // Update in the registration store
    dispatch(updateRegistrationInput({ group: InputGroupKeys.PERSONAL_DATA, key: PersonalDataFieldKeys.LANGUAGE, value: newLang }))

    // Switch to correct localized route
    const { route, slug } = translateRoute(asPath, newLang, language as Language)

    if (route === '/fr' || route === '/nl') {
      return router.push({ pathname: route, query: slug ? { slug } : undefined }, route, { locale: false })
    }

    return router.push({ pathname, query: { slug } }, route, { locale: false })
  }

  return (
    <ul className={styles['language-switcher']}>
      {SUPPORTED_LANGUAGES.map((lan: string) => {
        return (
          <li
            key={lan}
            className={classNames({ [styles['is-active']]: language === lan })}
            onClick={() => {
              if (language !== lan) return changeLanguage(lan as Language)
            }}
            role="presentation"
          >
            {lan.toUpperCase()}
          </li>
        )
      })}
    </ul>
  )
}

export default LanguageSwitcher
